module.exports = __webpack_public_path__ + "img/gezi.cac0f8e9.svg";